<div class="flex flex-col items-center gap-8">
  <h1 class="text-4xl font-bold md:text-5xl">Pricing</h1>
  <p class="text-balance text-center text-xl">
    Start for free with Live Updates. Upgrade to access Native Builds and App
    Store Publishing. No hidden fees, no surprises. <b>Join 1000+ customers.</b>
  </p>
  <div class="flex items-center gap-3">
    <div class="flex">
      <img
        src="assets/images/team/nicogenz-96.jpg"
        alt="Nico Genz"
        class="size-6 rounded-full object-cover shadow-md ring-2 ring-white"
      />
      <img
        src="assets/images/team/ehsanbarooni-96.jpg"
        alt="Ehsan Barooni"
        class="-ml-2 size-6 rounded-full object-cover shadow-md ring-2 ring-white"
      />
      <img
        src="assets/images/team/robingenz-96.jpg"
        alt="Robin Genz"
        class="-ml-2 size-6 rounded-full object-cover shadow-md ring-2 ring-white"
      />
    </div>
    <div>
      <span class="text-sm text-gray-700">Enterprise needs?</span>&nbsp;
      <button
        (click)="handleContactSales()"
        class="text-sm font-medium text-gray-900 hover:text-gray-700 hover:underline"
        type="button"
      >
        Talk to our team
      </button>
    </div>
  </div>
</div>
